module.exports = __webpack_public_path__ + "static/media/shaff1185.b1019a85.jpg";